import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class SidebarInternalService {
  public sidebarMinimized = new BehaviorSubject<boolean | null>(null);
  public sidebarMinimized$: Observable<boolean> = <Observable<boolean>>(
    this.sidebarMinimized.asObservable().pipe(filter(value => value != null))
  );
}
